import { AsyncPipe, NgClass } from '@angular/common';
import { Component, OnInit, Optional, input, output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslocoDirective } from '@jsverse/transloco';
import { DailyChallengeStatusApi } from '@kp/purposeful-day/daily-challenge-status.api';
import { StreakBloc } from '@kp/streaks/streak.bloc';
import { MockComponent } from '@kutil/test';
import { SvgIconComponent } from 'angular-svg-icon';

const DEFAULT_CLOSE_TIME = 3000;

@Component({
  selector: 'kp-modal-purposeful-day',
  standalone: true,
  templateUrl: './modal-purposeful-day.component.html',
  styleUrls: ['./modal-purposeful-day.component.scss'],
  imports: [SvgIconComponent, AsyncPipe, RouterLink, TranslocoDirective, NgClass],
})
export class ModalPurposefulDayComponent implements OnInit {
  constructor(
    public streakBloc: StreakBloc,
    @Optional() private _dailyChallengeStatusApi?: DailyChallengeStatusApi
  ) {}

  closeOnTimer = input<boolean>(false);
  closeTime = input<number>(DEFAULT_CLOSE_TIME);

  closeClicked = output<void>();

  totalCompleted = 0;

  ngOnInit() {
    this.streakBloc.refreshStreaks();
    this._dailyChallengeStatusApi?.getTotalCompleted().then((result) => {
      if (typeof result === 'number') {
        this.totalCompleted = result;
      }
    });
  }

  onAnimationStart() {
    if (this.closeOnTimer() !== false) {
      setTimeout(() => this.closeClicked.emit(), this.closeTime());
    }
  }
}

export const MockModalPurposefulDayComponent = MockComponent({
  selector: 'kp-modal-purposeful-day',
  inputs: ['closeOnTimer', 'closeTime'],
});
